module.exports = __webpack_public_path__ + "912deb0374f9d4bed22c2507453bb697.svg";